import './../../../scss/module/review/review.scss'

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('review-form');
  if (!form || !form.classList.contains('collapse')) return;
  var hasErrors = form.querySelector(
    '.is-invalid, .invalid-feedback, [aria-invalid="true"]'
  );
  // Deep-link from a review-collection email/SMS: ?avis=1 pre-opens the form.
  var wantsReview = /[?&]avis=1(&|$)/.test(window.location.search);
  if (!hasErrors && !wantsReview) return;
  if (!form.classList.contains('show')) form.classList.add('show');
  var btn = document.querySelector(
    '[data-bs-toggle="collapse"][data-bs-target="#review-form"]'
  );
  if (btn) btn.setAttribute('aria-expanded', 'true');
  form.scrollIntoView({behavior: 'smooth', block: 'center'});
  var firstInvalid = form.querySelector(
    'input.is-invalid, textarea.is-invalid, select.is-invalid'
  );
  var focusable = firstInvalid ||
    form.querySelector('input, textarea, select');
  if (focusable && focusable.focus) focusable.focus({preventScroll: true});
});
